interface CacheService {
  clearAuthCache(): void;
  clearAllCache(): void;
}

class CacheServiceImpl implements CacheService {
  private queryClient: any = null;

  setQueryClient(queryClient: any): void {
    this.queryClient = queryClient;
  }

  clearAuthCache(): void {
    if (this.queryClient) {
      // Clear specific authentication-related queries
      this.queryClient.removeQueries({ queryKey: ["userProfile"] });
      this.queryClient.invalidateQueries({ queryKey: ["userProfile"] });
    }
  }

  clearAllCache(): void {
    if (this.queryClient) {
      this.queryClient.clear();
    }
  }
}

export const cacheService = new CacheServiceImpl();